function fullName(obj) {
  if (obj?.name?.length > 0) return obj?.name;

  if (!obj?.firstName?.length && !obj?.lastName?.length) {
    return 'N/A';
  }

  let name = [];

  if (obj?.firstName?.length) {
    name.push(obj?.firstName);
  }

  if (obj?.lastName?.length) {
    name.push(obj?.lastName);
  }

  return name.join(' ');
}

export default fullName;
